import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ShieldCheck } from "lucide-react";
import { BrandBadge } from "@/components/BrandMark";
import { api, formatApiErrorDetail, setFallbackToken } from "@/lib/api";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Those two passwords don't match");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      if (data.token) setFallbackToken(data.token);
      window.location.href = "/dashboard";
    } catch (err) {
      setBusy(false);
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
  };

  return (
    <div className="min-h-screen bg-royal-deep flex items-center justify-center px-5 py-12">
      <div data-testid="reset-password-page"
           className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl">
        <BrandBadge />
        <h1 className="font-display text-3xl font-bold text-royal-deep mt-6">Choose a new password</h1>
        <p className="text-sm text-muted-foreground mt-2 mb-8">
          This link works once. Pick something at least 8 characters long with letters and numbers.
        </p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-wider text-muted-foreground">New password</Label>
            <Input data-testid="reset-password-input" type="password" required value={password}
                   onChange={(e) => setPassword(e.target.value)} className="mt-1.5 h-11" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-muted-foreground">Confirm password</Label>
            <Input data-testid="reset-password-confirm-input" type="password" required value={confirm}
                   onChange={(e) => setConfirm(e.target.value)} className="mt-1.5 h-11" />
          </div>
          {error && <p data-testid="reset-password-error" className="text-sm text-destructive">{error}</p>}
          <Button data-testid="reset-password-submit-btn" type="submit" disabled={busy}
                  className="w-full h-12 bg-royal hover:bg-royal-deep text-white font-semibold">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> :
              <span className="inline-flex items-center gap-2"><ShieldCheck className="h-4 w-4" /> Set password & sign in</span>}
          </Button>
        </form>
        <button type="button" data-testid="reset-password-back-btn" onClick={() => navigate("/login")}
                className="mt-5 w-full text-xs font-semibold text-royal hover:text-gold">
          Back to sign in
        </button>
      </div>
    </div>
  );
}
